// The first path segments that are fixed routes and not app codes. Keep in sync with getHeweconRouter.js.
const RESERVED_PATH_SEGMENTS = new Set([
    "", "users", "apps", "login", "create-account", "recover-account", "forgot-password", "admin", "pdf-generation",
    "redirect", "s", "api", "src"
]);

// The path starts with a slash, so the first segment is the second piece.
const getFirstSegment = (path) => path.split(/[/?#]/)[1] ?? "";

const isAppSegment = (segment) => !RESERVED_PATH_SEGMENTS.has(segment);

/**
 * True when the user is inside one app and the url points into a different one, e.g. from /westfix/top-up to an
 * invoice in /hewecon/bills/123. Such links are opened in a new tab so the user keeps their place in the first app.
 * Links from pages that are not inside an app (the app list, the admin pages) behave as usual.
 */
const isOtherAppUrl = (url, currentPath = location.pathname) => {
    if (typeof url !== "string" || !url.startsWith("/") || url.startsWith("//")) {
        return false;
    }
    const currentApp = getFirstSegment(currentPath);
    const targetApp = getFirstSegment(url);
    return isAppSegment(currentApp) && isAppSegment(targetApp) && currentApp !== targetApp;
};

export default isOtherAppUrl;
